import checkitTheme from '@checkit/react-components/checkit-theme';
import {blue} from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

const {palette, ...rest} = checkitTheme;
const {primary, ...paletteRest} = palette;

export const officeTheme = createTheme({
  palette: {
    primary: {
      main: blue['900']
    },
    ...paletteRest
  },
  ...rest
});
